import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=b0f3b400&scoped=true&"
import script from "@/scripts/Activity/Transcript/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Activity/Transcript/index.js?vue&type=script&lang=js&"
import style0 from "./Transcript.vue?vue&type=style&index=0&id=b0f3b400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f3b400",
  null
  
)

export default component.exports